export default "__VITE_ASSET__B12Ny38H__"